"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _styles = require("@material-ui/styles");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: (0, _defineProperty2.default)({
      color: theme.colors.black,
      display: 'flex',
      alignItems: 'center',
      zIndex: theme.zIndex.nav,
      position: 'fixed',
      top: 0,
      height: theme.functions.toRem(theme.variables.navHeight),
      minWidth: '20rem',
      // 320px
      width: '100%',
      backgroundColor: theme.colors.navBackground,
      borderBottom: '1px solid #cbd5e0',
      // Be mindful of Banner component styles
      paddingLeft: '.75rem',
      paddingRight: '.75rem'
    }, theme.breakpoints.gte.mobile.portrait, {
      paddingLeft: '1rem',
      paddingRight: '1rem'
    })
  };
});
/*:: type Props = {
  children: React.Node
};*/
var Nav = function Nav(_ref /*:: */) {
  var children = _ref /*:: */.children;
  var classes = useStyles();
  return /*#__PURE__*/React.createElement("nav", {
    className: classes.root
  }, children);
};
Nav.displayName = 'Nav';
var _default = exports.default = Nav;
//# sourceMappingURL=Nav.js.map